import { render, staticRenderFns } from "./UploadFileModal.vue?vue&type=template&id=63dbc1d4&"
import script from "./UploadFileModal.vue?vue&type=script&lang=js&"
export * from "./UploadFileModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports